<template>
  <div>
    <v-layout align-center style="height:100vh">
      <v-flex xs4 lg4 xl4 hidden-md-and-down class="session-left">
        <v-spacer>&nbsp;</v-spacer>
      </v-flex>
      <v-flex xs12 sm12 md12 lg8 xl8 class="text-xs-center">
        <v-container>
          <v-layout row wrap>
            <v-flex lg4>
              <v-spacer>&nbsp;</v-spacer>
            </v-flex>
            <v-flex lg4>
              <div class="text-xs-center text-lg-center">
                <img :src="appLogo" class="img-responsive mb-3" width="200" height="78">
                <br>
                <span style="font-size:21px;font-weight:410">Cambiar contraseña</span>
                <p class="mt-4" style="font-size:12px">Ingrese el código recibido</p>
                <v-form v-if="openForm" v-model="validChange" class="mb-4">
                  <v-text-field label="Nueva contraseña" v-model="newPassword" type="password"
                    :rules="[rules.required, rules.validPassword]"></v-text-field>
                  <v-text-field label="Confirmar contraseña" v-model="confirmPassword" type="password"
                    :rules="[rules.required, rules.confirmPass, rules.validPassword]"></v-text-field>
                  <v-btn :loading="loadingButtom" :disabled="!validChange || newPassword != confirmPassword || loadingButtom"
                    large @click="changePassword()" color="primary">RESTAURAR CONTRASEÑA</v-btn>
                </v-form>
                <v-form v-if="!openForm" ref="formCode" v-model="valid" class="mb-4">
                  <v-text-field :rules="[rules.required]" label="Ingrese el código" v-model="code" type="text"
                    required></v-text-field>
                  <v-btn :loading="loadingButtom" :disabled="!valid || loadingButtom" large @click="SendCode()"
                    color="primary">ENVIAR CÓDIGO</v-btn>
                </v-form>
              </div>
            </v-flex>
            <v-flex lg4>
              <v-spacer>&nbsp;</v-spacer>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import AppConfig from "@/config/AppConfig";
import SessionSliderWidget from "@/components/Widgets/SessionSlider";
import { i18n } from "@/main";
import kafkaService from "../../services/kafkaService";

export default {
  data() {
    return {
      loadingButtom: false,
      appLogo: AppConfig.appLogo2,
      code: "",
      openForm: "",
      confirmPassword: "",
      newPassword: "",
      valid: false,
      validChange: false,
      passwordRules: [v => !!v || i18n.t("message.requiredPassword")],
      rules: {
        required: value => !!value || "Campo Requerido",
        confirmPass: value =>
          value == this.newPassword || "Las contraseñas no coinciden",
        validPassword: value => {
          const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[()/$@$!%*?&_#'"<>=^.,:;-])([A-Za-z\d/()$@$!%*?&_#'"<>=^.,:;-]|[^ ]){8,15}$/;
          return (
            pattern.test(value) ||
            "La contraseña debe tener como mínimo 8 caracteres e incluir mayúsculas, números y caracteres especiales"
          );
        }
      }
    };
  },
  mounted() {
    //this.connect();
  },
  methods: {
    async changePassword() {
      this.loadingButtom = true;

      if (localStorage.getItem("tokenPassword")) {

        if (this.confirmPassword === this.newPassword) {

          let params = {
            email: localStorage.getItem("emailTemp"),
            code: this.code,
            password: this.newPassword
          };

          try {
            const res = await this.$store.dispatch("saveNewPass", params);

            if (res.data.code == 200) {

              try {
                await kafkaService.sendChangePassword(
                  params.email,
                  params.password
                );
                console.log("Kafka enviado");
              } catch (kafkaError) {
                console.error("Error Kafka:", kafkaError);
              }

              this.$root.$emit(
                "showSnackBar",
                "Contraseña Cambiada",
                "accent"
              );

              this.$router.push("/session/login");

            } else {
              this.$root.$emit(
                "showSnackBar",
                "Código Incorrecto",
                "error"
              );
            }

          } catch (error) {
            console.error("Error general:", error);

            this.$root.$emit(
              "showSnackBar",
              "Error al cambiar contraseña",
              "error"
            );
          }

        } else {
          this.$root.$emit(
            "showSnackBar",
            "Las contraseñas no coinciden",
            "error"
          );
        }

      }

      this.loadingButtom = false;
    },

    SendCode() {
      this.loadingButtom = true;

      if (this.code !== "") {

        var objectCode = {
          email: localStorage.getItem("emailTemp"),
          code: this.code
        };

        this.$store.dispatch("confirmaCodeRecover", objectCode)
          .then(res => {
            if (res.data.data.valid) {
              this.openForm = true;
            } else {
              this.$root.$emit("showSnackBar", "Código Incorrecto", "error");
              this.code = "";
              this.$refs.formCode.reset();
            }
          })
          .catch(() => {
            this.$root.$emit("showSnackBar", "Error validando código", "error");
          })
          .finally(() => {
            this.loadingButtom = false;
          });

      } else {
        this.$root.$emit("showSnackBar", "Ingrese el código", "error");
        this.loadingButtom = false;
      }
    }
  },
  SendCode() {
    this.loadingButtom = true;
    if (this.code !== "") {
      var objectCode = {
        email: localStorage.getItem("emailTemp"),
        code: this.code
      };
      this.$store.dispatch("confirmaCodeRecover", objectCode).then(res => {
        //console.log(res)
        if (res.data.data.valid) {
          this.loadingButtom = false;
          this.openForm = true;
        } else {
          this.loadingButtom = false;
          this.$root.$emit("showSnackBar", "Código Incorrecto", "error");
          this.code = "";
          this.$refs.formCode.reset();
        }
      });
    } else {
      this.$root.$emit("showSnackBar", "Ingrese el código", "error");
    }
  }
}
</script>